import { AxiosPromise } from 'axios'
import { http } from '@/api/httpAxios'
import createURLParams from '@/api/datasource/createURLParams'
import { systemImportNames } from '@/config/publications/systemNames'

export default class ImportProcessAPI {
  public static startImportPublication(arg: {
    type: string
    data?: any
    file?: File
    preview?: boolean
    year?: number
  }): AxiosPromise {
    const { type, data, file, preview, year } = arg
    let path = `/import/${type}`
    if (preview) {
      path += '/preview'
    }
    if (year) {
      path += `?year=${year}`
    }
    if (file) {
      const fd = new FormData()
      const params = new URLSearchParams()
      if (type === systemImportNames.Scopus) {
        params.append('fromFile', 'true')
      }
      fd.append('fileForImport', file)
      return http.post(path, fd, { params })
    } else {
      return http.post(path, data)
    }
  }

  public static getImportHistory(
    limit: number,
    offset: number,
    sort: [] | null,
    filter: { [k: string]: any } | null
  ): AxiosPromise {
    const params = createURLParams(limit, offset, sort, filter, false)
    return http.get('/general/history', { params })
  }

  public static getImportStatus(): AxiosPromise {
    return http.get('/import/status')
  }
}
